import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getInstallButtonClickedEvent, getMarketplaceInteractionEvent, getPageViewedEvent } from 'marketplace-ui-tracking/events/marketplace';
export const SCREEN = 'listing details';
export const REVIEW_SCREEN = 'listing details review';
export const useTracking = ({
  appContext,
  companyName,
  embed,
  installed,
  isPreview,
  isReviewLink,
  listingId,
  slug,
  sourceId,
  type
}) => {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const trackInteraction = eventProps => {
    if (isPreview) {
      return;
    }
    trackMarketplaceEvent(getMarketplaceInteractionEvent(Object.assign({
      companyName,
      embed,
      inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
      installed,
      listingId,
      screen: isReviewLink ? REVIEW_SCREEN : SCREEN,
      slug,
      sourceId: [sourceId],
      type
    }, eventProps)));
  };
  const trackInstall = eventProps => {
    if (isPreview) {
      return;
    }
    trackMarketplaceEvent(getInstallButtonClickedEvent(Object.assign({
      companyName,
      embed,
      inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
      listingId,
      screen: isReviewLink ? REVIEW_SCREEN : SCREEN,
      slug,
      sourceId: [sourceId],
      type
    }, eventProps)));
  };
  const trackPageViewed = () => {
    if (isPreview) {
      return;
    }
    trackMarketplaceEvent(getPageViewedEvent({
      companyName,
      embed,
      inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
      installed,
      screen: isReviewLink ? REVIEW_SCREEN : SCREEN,
      sourceId: [`${type}__${sourceId}`],
      slug,
      type
    }));
  };
  return {
    trackInstall,
    trackInteraction,
    trackPageViewed
  };
};